import { render, staticRenderFns } from "./ProfilesList.vue?vue&type=template&id=7714491a&scoped=true&"
import script from "./ProfilesList.vue?vue&type=script&lang=js&"
export * from "./ProfilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7714491a",
  null
  
)

export default component.exports